import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { run, useToast } from '../hooks';

/** Add a site: start its first scan. */
export function NewSitePage() {
  const navigate = useNavigate();
  const { toast, show } = useToast();
  const [url, setUrl] = useState('');
  const [email, setEmail] = useState('dev@example.com');
  const [pages, setPages] = useState(40);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    const r = await run(api.createScan(url, email, pages), show, 'Scan started');
    setBusy(false);
    if (r) navigate(`/sites/${r.siteId}`);
  }

  return (
    <div>
      <div className="topbar">
        <div>
          <h1>Add a site</h1>
          <p className="muted small">Scan a website to build its Springboard. The first scan publishes automatically.</p>
        </div>
        <Link className="btn sm" to="/sites">All sites</Link>
      </div>
      <form className="card grid" onSubmit={submit} style={{ gap: 14, maxWidth: 640 }}>
        <label className="field">
          Website URL
          <input className="input" placeholder="https://yourwebsite.com" value={url} onChange={(e) => setUrl(e.target.value)} required autoFocus />
        </label>
        <label className="field">
          Owner email
          <input className="input" type="email" placeholder="owner@company.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="field" style={{ width: 160 }}>
          Max pages
          <input className="input" type="number" min={1} max={2000} value={pages} onChange={(e) => setPages(Number(e.target.value))} />
        </label>
        <div>
          <button className="btn primary" disabled={busy}>
            {busy ? 'Starting…' : 'Scan the site'}
          </button>
        </div>
      </form>
      {toast && <div className={`toast${toast.err ? ' err' : ''}`}>{toast.text}</div>}
    </div>
  );
}
